export const SOURCE_CONTROL_PUSH_MODAL_KEY = 'sourceControlPush';
export const SOURCE_CONTROL_PULL_MODAL_KEY = 'sourceControlPull';
export const SOURCE_CONTROL_PULL_RESULT_MODAL_KEY = 'sourceControlPullResult';
